// extracted by mini-css-extract-plugin
export default {"wrapper":"DQhTc6","image":"hIa7jA","qr-code-wrap":"AlhI54","qr-code-image":"bOiGEs"};